import { render, staticRenderFns } from "./aragingkolektor.vue?vue&type=template&id=5476071f"
import script from "./aragingkolektor.vue?vue&type=script&lang=js"
export * from "./aragingkolektor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports